
import { headerName } from '@telstra-connect/utils/helper/common-static-data'
import global from '@applications'
import { QueryClient } from '@tanstack/react-query'

export const setDefaultMenuItem = (value) => {
  window.localStorage.setItem('selectedMenuItem', value)
}

// Methods for checking user and page access

export const HasAggregatedViewAccess = (props) => {
  return props.data && props.data.viewAggregatedYPSpage
}

export const HasAggregatedLegacyViewAccess = () => {
  return global.applications['Request Management'].featureFlags.aggregatedViewForLegacySC
}

export const getCompanyIdOnInit = (userProfile, authorizedRequestState) => {
  let companyId = ''
  if (userProfile && userProfile.companyId && userProfile.companyId !== 'undefined') {
    companyId = userProfile.companyId
  } else {
    companyId =
      authorizedRequestState &&
        authorizedRequestState.data &&
        authorizedRequestState.data.lastSelectedCompanies[0] &&
        authorizedRequestState.data.lastSelectedCompanies[0].cidn
        ? authorizedRequestState.data.lastSelectedCompanies[0].cidn
        : ''
  }
  return companyId
}

export const getCompanyId = (state) => {
  const companyId = state &&
    state.user &&
    state.user.oauth &&
    state.user.oauth.profile &&
    state.user.oauth.profile.companyId &&
    state.user.oauth.profile.companyId !== 'undefined' ?
    state.user.oauth.profile.companyId : ''

  return companyId
}

export const isInternationalCustomer = (cidn) => {
  if (cidn === null || cidn === undefined) {
    return false
  }
  return cidn.toString().length >= 5 && cidn.toString().length <= 8 ? true : false
}

export const IsUserLegacyReadOnly = (props) => {
  return (
    global.applications['Request Management'].featureFlags.customProperties &&
    global.applications['Request Management'].featureFlags.customProperties.roles ===
    headerName.readOnlyUser &&
    HasLegacyLandingPageAccess(props)
  )
}

export const isAccessibilityEnabled = (): boolean => {
  return global?.applications && global.applications["Order Express"]?.intShopAccessibility;
};

export const HasLegacyLandingPageAccess = (props) => {
  return (
    global.applications['Request Management'].featureFlags.aggregatedViewForLegacySC &&
    props.data &&
    !props.data.viewAggregatedYPSpage
  )
}

export const reactQueryClient = new QueryClient()


/* context menu options for mobile services */
export interface IContextMenuOptionProps {
  status: string
  earlyTerminationCharges: string
  mobileCatalogueUrl: string
  adaptiveCatalogue: boolean
  deactivatedDate?: string
}

export const isMSCSPEnabled = (): boolean => {
  return (
    global.applications['Order Express'].intMSCSPEnabled
  )
}
export const isANPEXEnabled = (): boolean => {
  return (
    global.applications['Order Express'].intIsANPEXEnabled
  )
}
